import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Stack, FormControlLabel, Checkbox } from "@mui/material"

import LoadingButton from "widgets/common/LoadingButton"
import PopUp from "widgets/common/PopUp"
import TermsAndConditionsContent from "widgets/user/TermsAndConditionsContent"

interface TermsAndConditionsModalProps {
  open: boolean
  onClose: () => void
  onComplete: () => Promise<void>
  username: string
  accessToken?: string
}

const TermsAndConditionsModal = ({
  open,
  onClose,
  onComplete,
}: TermsAndConditionsModalProps) => {
  const { t } = useTranslation()
  const [readAndAgreed, setReadAndAgreed] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleAccept = async () => {
    setIsLoading(true)
    await onComplete()
    setIsLoading(false)
  }

  return (
    <PopUp
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      actions={
        <Stack width="100%" py={1} gap={2} alignItems="center">
          <FormControlLabel
            label={t("terms_and_conditions.READ_AND_AGREED")}
            control={
              <Checkbox
                size="medium"
                checked={readAndAgreed}
                onChange={() => setReadAndAgreed(!readAndAgreed)}
              />
            }
          />
          <LoadingButton
            loading={isLoading}
            variant="contained"
            disabled={!readAndAgreed}
            onClick={handleAccept}
          >
            {t("terms_and_conditions.CONTINUE")}
          </LoadingButton>
        </Stack>
      }
    >
      <TermsAndConditionsContent />
    </PopUp>
  )
}
export default TermsAndConditionsModal
